import { render, staticRenderFns } from "./sysCom.vue?vue&type=template&id=d047f052&scoped=true"
import script from "./sysCom.vue?vue&type=script&lang=js"
export * from "./sysCom.vue?vue&type=script&lang=js"
import style0 from "./sysCom.vue?vue&type=style&index=0&id=d047f052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d047f052",
  null
  
)

export default component.exports